import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-center px-4 py-24 text-center md:px-8">
      <span className="font-heading text-6xl font-bold text-primary-200 md:text-8xl">404</span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        页面不存在或已被移除
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-500">
        你访问的页面可能已经下线，或者链接地址有误。不如回到首页，看看最新的 AI 短剧推荐。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          <span className="whitespace-nowrap">返回首页</span>
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100"
        >
          <i className="ri-compass-3-line"></i>
          <span className="whitespace-nowrap">浏览短剧分类</span>
        </Link>
      </div>
    </div>
  );
}